import { css, type Theme } from "@emotion/react";

const STAR_COLOR = "#c87842";

export const row = css`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const stars = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.xsmall};
`;

export const star = css`
  width: 13px;
  height: 13px;
  color: ${STAR_COLOR};
`;
